import { render, staticRenderFns } from "./AS_VldScheme.vue?vue&type=template&id=22b6c88c&scoped=true&"
import script from "./AS_VldScheme.vue?vue&type=script&lang=js&"
export * from "./AS_VldScheme.vue?vue&type=script&lang=js&"
import style0 from "./AS_VldScheme.vue?vue&type=style&index=0&id=22b6c88c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b6c88c",
  null
  
)

export default component.exports